<template>
  <header class="header">
    <!-- 顶部信息栏 -->
    <div class="top-bar">
      <div class="container">
        <div class="top-bar-left">
          <span>信息化项目造价咨询专家</span>
        </div>
        <div class="top-bar-right">
          <span>
            <img  src="/img/phone.svg">13525947399
          </span>
          <span class="email-span">
            <img style="margin-right: 5px; margin-bottom: 3px;" src="/img/email.svg">hnzlzygczx@163.com
          </span> 
        </div>
<!--          <el-dropdown trigger="click" @command="handleLanguageChange">-->
<!--            <span class="language-selector">-->
<!--              {{ currentLanguage === 'zh' ? '中文' : 'English' }} <i class="el-icon-arrow-down"></i>-->
<!--            </span>-->
<!--            <el-dropdown-menu slot="dropdown">-->
<!--              <el-dropdown-item command="zh">中文</el-dropdown-item>-->
<!--              <el-dropdown-item command="en">English</el-dropdown-item>-->
<!--            </el-dropdown-menu>-->
<!--          </el-dropdown>-->
<!--          <a href="#" class="login-btn"><i class="el-icon-user"></i> 客户登录</a>-->
      </div>
    </div>
    
    <!-- 主导航栏 -->
    <nav class="main-nav">
      <div class="container">
        <div class="logo">
          <router-link to="/">
            <div style="height: 50px; display: flex; align-items: center; font-size: 24px; font-weight: bold; color: #1ebec8;">
              <img src="/img/logo.png" alt="公司图片">
            </div>
          </router-link>
        </div>
        
        <div class="nav-menu" :class="{ 'active': isMenuOpen }">
          <ul>
            <li v-for="(item, index) in menuItems" :key="index" 
                :class="{ 'active': isActiveRoute(item.path), 'has-submenu': item.children.length > 0 }">
              <a href="javascript:;" @click="navigateTo(item.path)" >{{ item.title }}</a>
              <div class="submenu" v-if="item.children.length > 0 && !isMobile">
                <ul >
                  <li v-for="(child, childIndex) in item.children" :key="childIndex">
                    <a href="javascript:;" @click="navigateTo(child.path)">{{ child.title }}</a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        
        <div class="menu-toggle" @click="toggleMenu">
          <i :class="isMenuOpen ? 'el-icon-close' : 'el-icon-menu'"></i>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'Header',
  computed: {
    ...mapState(['isMenuOpen', 'menuItems', 'currentLanguage']),
    // 添加计算属性检测是否为移动设备
    isMobile() {
      return window.innerWidth <= 892;
    }
  },
  watch: {
    isMenuOpen(newVal) {
      this.controlBodyScroll(!newVal);
    }
  },
  methods: {
    // 控制body滚动
    controlBodyScroll(allowScroll) {
      document.body.style.overflow = allowScroll ? '' : 'hidden'
    },
    ...mapMutations(['toggleMenu', 'setLanguage','setMenuOpen']),
    handleLanguageChange(lang) {
      this.setLanguage(lang)
    },
    // 覆盖默认的closeMenu方法  
    closeMenu() {
      this.setMenuOpen(false);
      this.controlBodyScroll(true)

    },
    
    // 检查当前路由是否激活
    isActiveRoute(path) {
      // 对于不带查询参数的路径，直接比较
      if (this.$route.path === path) {
        return true
      }
      
      // 处理关于我们页面的特殊情况
      if (path === '/about' && this.$route.path === '/about') {
        return true
      }
      
      return false
    },
    
    // 处理导航逻辑
    navigateTo(path) {
      // 先关闭菜单
      this.closeMenu();
      
      if (path.includes('?')) { 
        // 如果包含查询参数，需要特殊处理
        const [basePath, queryString] = path.split('?')
        const query = {}
        
        // 解析查询字符串
        queryString.split('&').forEach(param => {
          const [key, value] = param.split('=')
          query[key] = value
        })
        
        // 使用路由对象进行导航
        this.$router.push({ path: basePath, query })
      } else {
        // 普通路径直接导航
        this.$router.push(path)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  z-index: 1000;
}

// 顶部信息栏样式
.top-bar {
  background-color: #1ebec8;
  padding: 8px 0;
  font-size: 13px;
  color: #fff;
  
  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .top-bar-left {
    span {
      margin-right: 20px;
      font-size: 14px;
      font-weight: bold;
      letter-spacing:2px;
      i {
        margin-right: 5px;
        color: #1ebec8;
      }
    }

    // 手机端样式调整
    @media (max-width: 768px) {
      span {
        font-size: 12px !important; // 减小字体大小
      
      }
    }
  }
  
  .top-bar-right {
    display: flex;
    align-items: center;
    span{
      font-weight: bold;
      img {
        width: 18px;
        height: 18px;
        vertical-align: middle;
        margin-left: 20px;
       }
    }

    // 手机端隐藏邮箱
    @media (max-width: 768px) {
      .email-span {
        display: none;
      }
    }
    .language-selector {
      margin-right: 15px;
      cursor: pointer;
      
      &:hover {
        color: #1ebec8;
      }
      
      i {
        font-size: 16px;
        margin-left: 5px;
      }
    }
    
    .login-btn {
      color: #666;
      
      i {
        margin-right: 5px;
      }
      
      &:hover {
        color: #1ebec8;
      }
    }
  }
}

// 主导航栏样式
.main-nav {
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  
  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 80px;
  }
  
  .logo {
    img {
      height: 40px;
    }
  }
  
  .nav-menu {
    ul {
      display: flex;
      margin: 0;
      padding: 0;
      list-style: none;
      
      li {
        position: relative;
        margin: 0 10px;
        
        a {
          display: block;
          padding: 30px 15px;
          font-size: 16px;
          color: #333;
          font-weight: 500;
        }
        
        &.active a,
        a:hover {
           color: #1ebec8;
        }
        
        // 下拉菜单样式
        .submenu {
          position: absolute;
          top: 100%;
          left: 50%;
          transform: translateX(-50%) translateY(0);
          width: auto;
          min-width: 200px;
          background-color: #fff;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
          opacity: 0;
          visibility: hidden;
          z-index: 10;
          padding: 0;
          margin-top: -1px; /* 消除间隙 */
          border-radius: 4px;
          overflow: hidden;
          
          ul {
            display: flex;
            flex-direction: row;
            white-space: nowrap;
            justify-content: center;
            margin: 0;
            padding: 0;
            width: 100%;
            
            li {
              margin: 0 1px;
              padding: 0;
              flex: 1;
              text-align: center;
              
              a {
                color: #333;
                padding: 15px 10px;
                font-size: 14px;
                font-weight: normal;
                border-bottom: 2px solid transparent;
                
                &:hover {
                  background-color: #f5f5f5;
                  color: #1ebec8;
                  border-bottom: 2px solid #1ebec8;
                }
              }
            }
          }
        }
        
        &:hover .submenu {
          opacity: 1;
          visibility: visible;
          transform: translateX(-50%) translateY(0);
        }
      }
    }
  }
  
  .menu-toggle {
    display: none;
    font-size: 24px;
    cursor: pointer;
    color: #333;
  }
}

// 响应式样式
@media (max-width: 892px) {
  .main-nav {
    
    .menu-toggle {
      display: block;
    }
    
    .nav-menu {
      position: fixed;
      top: 95px; // 顶部栏高度 + 主导航栏高度
      left: 0;
      width: 100%;
      height: 0;
      background-color: #fff;
      overflow: hidden;
      z-index: 100;
     
      
      &.active {
        height: calc(100vh - 88px);
        overflow-y: auto;
      
      }
      
      ul {
        flex-direction: column;
        padding: 20px 0;
        
        li {
          margin: 0;
          
          a {
            padding: 15px 20px;
          }
          
          .submenu {
            position: static;
            opacity: 1;
            visibility: visible;
            transform: none;
            box-shadow: none;
            display: block;
            padding: 0;
            min-width: 100%;
            left: 0;   
            ul {
              flex-direction: column;
              margin-left: 40px;
              
              li {
                     
                a {
                   width: 300px !important;   
                   text-align: left;
                   border-bottom: none;
                  &:hover {
                    background-color: #f9f9f9;
                    border-bottom: none;
                  }
                }
              }
            }
          }
          
          &:hover .submenu {
            display: block;
          }
        }
      }
    }
  }
}
</style>